    //Scroll to top button
    var topbutton = document.getElementById("top");

    // When the user scrolls down 20px from the top of the document, show the button
    window.onscroll = function() { scrollFunction() };

    function scrollFunction() {
        if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
            topbutton.style.display = "block";
        } else {
            topbutton.style.display = "none";
        }
    }

    // When the user clicks on the button, scroll to the top of the document
    function topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }



    // Code for footer collapsibles
    const collapsibles = document.querySelectorAll(".collapsible");
    collapsibles.forEach((item) =>
        item.addEventListener("click", function() {
            this.classList.toggle("collapsible--expanded");
        })
    );

    //Accordian buttons functions
    accordionFunction();

    function accordionFunction() {
        const acc = document.getElementsByClassName("accordion");
        var i;

        for (i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function() {
                this.classList.toggle("active");
                var panel = this.nextElementSibling;
                if (panel.style.display === "block") {
                    panel.style.display = "none";
                } else {
                    panel.style.display = "block";
                }
            });
        }
    }


    //Image folder crawl and load -- Reference https://www.youtube.com/watch?v=YuFxE3CUTtw
    // function loadImages() {
    //     //let file = "https://github.com/claing84/NorthCascadesPainting-Handyman/tree/master/xzzz511af";
    //     let file = "/xzzz511af";
    //     let columns = document.querySelectorAll(".column");

    //     //event handler on input type file
    //     file.onchange = () => {

    //         //get files from the directory
    //         for (const key in file.files) {
    //             if (file.files.hasOwnProperty(key)) {
    //                 const element = file.files[key];
    //                 if (element.type == "image/jpeg" || element.type == "image/png" || element.type == "image/jpg") {
    //                     let parent_column = minParent(columns);

    //                     let img = createImg(element.webkitRelativePath);

    //                     parent_column.appendChild(img);
    //                 }
    //             }
    //         }
    //     }
    // }
    // //Obtain parentNode which has minimum child
    // function minParent(parentNode) {
    //     let arry = [];

    //     //Get the children of parent node
    //     parentNode.forEach((element, i) => {
    //         arry[i] = element.children.length;
    //     });
    //     let min = Math.min.apply(null, arry);

    //     for (let i = 0; i < parentNode.length; i++) {
    //         if (parentNode[i].children.length == min) {
    //             return parentNode[i];
    //         }
    //     }
    // }

    // // Create images with source attribute
    // function createImg(imgsrc) {
    //     let img = document.createElement("img");
    //     img.setAttribute("src", imgsrc);
    //     img.className = "img";
    //     return img;
    // }